import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import {DisconnectTwitchButton} from './DisconnectTwitchButton';
import {ConnectTwitchButton} from './ConnectTwitchButton/ConnectTwitchButton';
import {Loader} from '../../system/Loader/Loader';
import {ActionHref} from '../../system/buttons';

export const General = ({profile, refresh}) => {
  if (profile) {
    let {isTwitchConnected, email, channel} = profile;
    return (
      <>
        <h4>General</h4>
        <hr />
        <Row className={'p-2'}>
          <Col sm={2}>Email</Col>
          <Col>{email}</Col>
        </Row>

        <Row className={'p-2'}>
          <Col sm={2}>Twitch Account</Col>
          <Col>
            {isTwitchConnected ? (
              <>
                Connected{' '}
                {channel && channel.url ? (
                  <>
                    as{' '}
                    <a
                      href={channel.url}
                      rel="noopener noreferrer"
                      target={'_blank'}
                    >
                      {channel.url}
                    </a>{' '}
                  </>
                ) : (
                  ''
                )}{' '}
                <DisconnectTwitchButton refresh={refresh} />
              </>
            ) : (
              <>
                Not connected <ConnectTwitchButton />
              </>
            )}
          </Col>
        </Row>

        <Row className={'p-2 pl-5'}>
          <ActionHref href={'/logout'}>Logout</ActionHref>
        </Row>
      </>
    );
  } else {
    return <Loader />;
  }
};
